
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dgNyv", function(module, exports) {
module.exports = JSON.parse("{\"jira.jira-notify-reaction.message-template.text.single-reaction-with-name\":\":bell: *{userName} ha reaccionado a tu comentario*\",\"jira.jira-notify-reaction.message-template.text.view-comment\":\"Ver comentario\"}");

});


//# sourceMappingURL=es.c643c123.js.map
